/* eslint-disable no-undef */
const config = {
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL,
  sentryDSN: process.env.REACT_APP_SENTRY_DSN,
  sentryEnv: process.env.REACT_APP_SENTRY_ENVIRONMENT,
  sentryRelease: process.env.REACT_APP_SENTRY_RELEASE,
};

export default config;
